import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { Organisation } from '../models/organisation.model';
import { Page } from '../models/page.model';

@Injectable({ providedIn: 'root' })
export class OrganisationService {
  private organisationsUrl = '/organisations';
  constructor(private http: HttpClient) {}

  getOrganisations(): Observable<Organisation[]> {
    return this.http.get<any>(this.organisationsUrl + '/all').pipe(
      map((response) => response.data),
      catchError(this.handleError),
    );
  }

  getOrganisation(id: number): Observable<Organisation> {
    return this.http.get<any>(this.organisationsUrl + '/' + id).pipe(
      map((response) => response.data),
      catchError(this.handleError),
    );
  }

  getOrganisationsAdvanced(
    pageIndex: number,
    itemsPerPage: number,
    sortColumnName: string,
    sortColumnOrder: string,
    filter: string,
    excludeUserOrg: boolean = false,
  ): Observable<Page<Organisation>> {
    let url = this.organisationsUrl + '?size=' + itemsPerPage + '&page=' + (pageIndex - 1);
    if (filter) {
      url += '&name=' + filter;
    }
    if (excludeUserOrg) {
      url += '&excludeUserOrganisation=true';
    }
    if (sortColumnName) {
      url += '&sort=' + sortColumnName + ',' + sortColumnOrder;
    }
    return this.http.get<any>(url).pipe(
      map((response) => response.data),
      catchError(this.handleError),
    );
  }

  save(organisation: Organisation): Observable<Organisation> {
    if (organisation.id) {
      return this.put(organisation);
    }
    return this.post(organisation);
  }

  delete(organisation: Organisation) {
    const url = `${this.organisationsUrl}/${organisation.id}`;

    return this.http.delete(url).pipe(catchError(this.handleError));
  }

  private handleError(error: any) {
    console.error('An error occurred', error);
    return throwError(() => error.message || error);
  }

  // Add new organisation
  private post(organisation: Organisation): Observable<Organisation> {
    return this.http.post<any>(this.organisationsUrl, organisation).pipe(
      map((res) => res.data),
      catchError(this.handleError),
    );
  }

  // Update existing organisation
  private put(organisation: Organisation) {
    const url = `${this.organisationsUrl}/${organisation.id}`;

    return this.http.put<any>(url, organisation).pipe(
      map((res) => res.data),
      catchError(this.handleError),
    );
  }
}
